import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
declare var $:any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {

  public datadetail:any=[];
  public appointmentListing:any=[];
  public CategoryList:any=[];
  public SubCategoryList:any=[];
  public SelectedCategoryList:any=[];
  public SelectedSubCategoryList:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any=0;
  public CurrentUrl:any=this.router.url;
  public addressList:any=[];
  public userid:any='';
  public showhide:boolean=true;
  public selectedFile: any = "";
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  public submitted:boolean = false;
  public Updates:boolean=false;

  profileData = new FormGroup({
  name:new FormControl('',Validators.compose([
    Validators.required , Validators.maxLength(30)])), 
  })


  SocailData = new FormGroup({
    footerEmail:new FormControl('',Validators.compose([
      Validators.required, Validators.email  ])),   
    // description:new FormControl('',Validators.compose([
    //   Validators.required])),
    contactNumber:new FormControl('',Validators.compose([
      Validators.required])), 
    facebookUrl:new FormControl('',Validators.compose([
      Validators.required])),
    instagramUrl:new FormControl('',Validators.compose([
      Validators.required])),
    twitterUrl:new FormControl('',Validators.compose([
      Validators.required])),
    pinterestUrl:new FormControl('',Validators.compose([
      Validators.required])),
  })
  
   get f1() { return this.profileData.controls; }
   get f() { return this.SocailData.controls; }


  constructor(public router: Router, public service: GlobalService) { 
    var mm:any= JSON.parse(localStorage.getItem('hva_login') || "{}");  
    this.userid=mm._id;
    this.getSocialData();   
    this.getuserData();   
   }

  ngOnInit(): void {
  }

  getSocialData(){
    this.loading=true;
    var url="footer";
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1){
        var self=this;
        this.datadetail= response.data;
        this.loading=false;
      }
    }))
  }

  getuserData(){
    this.loading=true;
    var url:any='user-detail/'+this.userid;  
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1){
        var self=this;
        this.loginDetail= response.data;      
        if(this.loginDetail.image=='' || this.loginDetail.image==undefined){
          this.imgURL=  'assets/images/avatars/avatar-2.png';
        } else {
          this.imgURL=  this.loginDetail.image;
        }
        localStorage.setItem('hva_login',<any> JSON.stringify(response.data));
        this.service.setSubject(response.data);
        this.showhide=true;
        this.loading=false;
        if(this.Updates){
          this.router.navigate(['/dashboard']);  
        }
      }
    }))
  }

  getUploadFileDetail(event: any) {
    //this.imageChangedEvent = event;
    if (event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
      var mimeType = event.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.service.dangerAlert("Only images are supported.");
        return;
      }
      var reader = new FileReader();
      this.imagePath = event.target.files;
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.imgURL = reader.result;
      };
       
    }

  }
  
  changeImage() {
    $("#file1").trigger("click");
  }

  onSubmit(){
    this.loading=true;     
    let formdata= new FormData();
    if(this.imgURL == ''){
      this.service.dangerAlert('Please upload the image');
      return
    } else {
      if(this.selectedFile!=''){
        formdata.append('profileImage',this.selectedFile);
      }
    }
    let userdetail :any= this.profileData;
    if(userdetail.valid){
    formdata.append('fullName',userdetail.value.name);
    this.service.updateFormData1(formdata,"update-profile").subscribe(((response:any)=>{
      if(response.success ==1){  
        this.Updates=true;
        this.getuserData();             
        this.loading=false; 
      }}))
    } else{
      window.scroll(0,0);
      this.loading=false; 
    }
  }

  onSubmit1(){
    this.submitted = true;    
      let userdetail = this.SocailData;
      if(userdetail.valid){
      var url='footer/' +this.datadetail._id;
            var detail:any={
              "footerEmail": userdetail.value.footerEmail,
              "facebookUrl":userdetail.value.facebookUrl,
              "instagramUrl": userdetail.value.instagramUrl,
              "linkedinUrl": userdetail.value.pinterestUrl,
              "tikTokUrl": userdetail.value.twitterUrl,
              "contactNumber": userdetail.value.contactNumber,
            }
            this.service.updateApi1(detail,url).subscribe(((response:any)=>{
              if(response.success ==1){         
                this.loading=false;  
                this.router.navigate(['/dashboard']);
              } else {
                this.service.dangerAlert(response.message);
                this.loading=false;
              }
            }), (error:any) => {
              this.loading=false;
            });
          } else{
            window.scroll(0,0);
          }
  }
}
